import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { reportSearchFrom } from '@/features/accounting-reports/api'
import {
  GeneralLedgerScreen,
  type GeneralLedgerSearch,
} from '@/features/accounting-reports/general-ledger-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/reports/general-ledger')({
  validateSearch: (search: Record<string, unknown>): GeneralLedgerSearch => ({
    ...reportSearchFrom(search),
    account_id:
      typeof search.account_id === 'string' && search.account_id !== ''
        ? search.account_id
        : undefined,
    journal_ids: reportSearchFrom(search).journal_ids,
    doc_type:
      typeof search.doc_type === 'string' && search.doc_type !== '' ? search.doc_type : undefined,
    party_type: ['customer', 'supplier', 'employee'].includes(String(search.party_type))
      ? (search.party_type as GeneralLedgerSearch['party_type'])
      : undefined,
    party_id: typeof search.party_id === 'string' && search.party_id ? search.party_id : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: GeneralLedgerRoute,
})

function GeneralLedgerRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <GeneralLedgerScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/accounting/reports/general-ledger', search: next })
      }
    />
  )
}
